define("ember-svg-jar/inlined/creator-home", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M14.56 7.023l-.677.91 2.427 2.369 1.773 1.738-2.461.257-3.675.385-.42 3.313-.35 2.765-1.727-2.193-1.307-1.657v10.78h17.524V7.023H14.56z\"/><path d=\"M9.473 2.333L7.338 5.192 2.333 3.045l2.859 4.293L2.333 9.03l3.279 1.458-1.902 4.947 4.445-2.403 2.217 2.811.536-4.223 4.585-.49-3.161-3.08 3.535-4.725-5.449 2.123-.945-3.115z\"/>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});